import { Fragment } from "react";
import { useLanguage } from "../../../../widgets/LangContext";
import { useSelector } from "react-redux";
import { NumberToNepaliNum } from "../../../../widgets/NumberFormat";
import AppURL from "../../../../widgets/AppURL";

const PrintAssetsReportView = () => {
    const { language } = useLanguage();
    const { menu_list } = useSelector((state) => state?.software);
    const { account_trial_balance_rpt_list, account_rpt_from_to_date_list } =
        useSelector((state) => state.accounts);
    const Org_Details = menu_list?.structure;

    const totals = {
        countpcs: 0,
        totpurchamt: 0,
        prvamt: 0,
        currpurchamt: 0,
        cursaleamt: 0,
        totamt: 0,
        deprecamt: 0,
        netamt: 0
    };

    // Group data by sglsn for rowspan calculation
    const groupedData = {};
    account_trial_balance_rpt_list?.results?.forEach((row, i) => {
        // Calculate totals
        totals.countpcs += row.countpcs || 0;
        totals.totpurchamt += row.totpurchamt || 0;
        totals.prvamt += row.prvamt || 0;
        totals.currpurchamt += row.currpurchamt || 0;
        totals.cursaleamt += row.cursaleamt || 0;
        totals.totamt += row.totamt || 0;
        totals.deprecamt += row.deprecamt || 0;
        totals.netamt += row.netamt || 0;

        // Group by sglsn
        if (!groupedData[row.sglsn]) {
            groupedData[row.sglsn] = [];
        }
        groupedData[row.sglsn].push(row);
    });

    // Flatten the grouped data with rowspan info
    const flattenedData = [];
    Object.keys(groupedData).forEach(sglsn => {
        const group = groupedData[sglsn];
        group.forEach((row, index) => {
            flattenedData.push({
                ...row,
                sglsnRowspan: index === 0 ? group.length : 0,
                subLedgerRowspan: index === 0 ? group.length : 0
            });
        });
    });
    return (
        <Fragment>
            <style>
                {`@media print {
                    @page {
                    size: A4 landscape;
                    page-break-before: always;
                    margin: 0.2in; 
                    border: 1px solid oklch(0.145 0 0); 
                    }
                }`}
            </style>
            <div className="bg-white h-screen">
                <div className="relative border-x border-t border-slate300 p-2">
                    <div className="relative">
                        <table className="w-full text-sm text-left rtl:text-right text-black">
                            <tbody>
                                <tr>
                                    <td
                                        className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language ? "font-public-sans" : "font-sangrila"
                                            }`}
                                    >
                                        {language ? "Reg. No.: " : "दर्ता नं.:"}:{" "}
                                        {language
                                            ? Org_Details?.org_reg
                                            : NumberToNepaliNum(Org_Details?.org_reg || "")}
                                    </td>
                                    <td className="w-[25%]"></td>
                                    <td className="w-[25%]"></td>
                                    <td
                                        align="right"
                                        className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language ? "font-public-sans" : "font-sangrila"}`}>
                                        {language ? "Phone: " : "फोन नम्बर:"}{" "}
                                        {language? Org_Details?.org_phone: NumberToNepaliNum(Org_Details?.org_phone || 0)}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        rowSpan={4}
                                        className="w-[25%] font-medium text-black whitespace-nowrap"
                                    >
                                        <img
                                            width={60}
                                            height={60}
                                            src={AppURL.BaseURL + Org_Details?.logo}
                                            alt=""
                                        />
                                    </td>
                                    <td
                                        align="center"
                                        colSpan={2}
                                        className={`w-[25%] text-black font-semibold text-[18px] ${language ? "font-public-sans" : "font-sangrila"
                                            }`}
                                    >
                                        {language
                                            ? Org_Details?.org_name
                                            : Org_Details?.org_name_nep}
                                    </td>
                                    <td className="w-[25%]"></td>
                                </tr>

                                <tr>
                                    <td
                                        align="center"
                                        colSpan={2}
                                        className={`w-[25%] text-black font-normal text-[12px] ${language ? "font-public-sans" : "font-sangrila"
                                            }`}
                                    >
                                        {language ? Org_Details?.org_add : Org_Details?.org_add_nep}
                                    </td>
                                    <td
                                        align="right"
                                        className={`w-[25%] text-[11px] text-black font-normal ${language ? "font-public-sans" : "font-sangrila"
                                            }`}
                                    >
                                        {language ? "Date: " : "मिति: "}{" "}
                                        {menu_list?.np_date}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        align="center"
                                        colSpan={2}
                                        className={`w-[25%] underline underline-2 text-black font-semibold text-[15px] ${language ? "font-public-sans" : "font-sangrila"}`}>
                                        {language ? "Assets Report" : "सम्पत्ति प्रतिवेदन"}
                                    </td>
                                    <td className="w-[25%]"></td>
                                </tr>
                                <tr>
                                    <td align="center" colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language ? "font-public-sans" : "font-sangrila"}`}>
                                        {language ? "Date: " : "मिति: "}
                                        {language ? account_rpt_from_to_date_list?.from_date : NumberToNepaliNum(account_rpt_from_to_date_list?.from_date || 0
                                            )}{" "}
                                        {language ? "from " : "बाट "}{" "}
                                        {language
                                            ? account_rpt_from_to_date_list?.to_date
                                            : NumberToNepaliNum(
                                                account_rpt_from_to_date_list?.to_date || 0
                                            )}{" "}
                                        {language ? "Upto " : "सम्म"}
                                    </td>
                                    <td align="right" className="w-[25%] text-[11px]"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="relative">
                    <Fragment>
                        <table className='w-full'>
                            <thead className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                                <tr className="text-[10px] text-gray700 bg-slate100 capitalize dark:bg-slate900 dark:text-gray-400 font-public-sans">
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Sub Ledger</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Particular</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Code</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Pic</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Purchase Amt</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Prev Year Pur Amt</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Current Year Pur Amt</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Current Year Sel Amt</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Total Amount</th>
                                    <th colSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Depression Rate</th>
                                    <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Total Amount</th>
                                </tr>
                                <tr className="text-[10px] text-gray700 bg-slate100 capitalize font-public-sans">
                                    <th scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600 w-10">%</th>
                                    <th scope="col" align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate600">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                 {flattenedData.map((row, i) => {
                                const code = row?.particularname?.split(" ").map(item=>item.charAt(0)).join("");
                                return(
                                    <tr key={i} className="bg-white text-[10px] text-slate800 dark:text-slate400 dark:bg-slate800 border-b font-public-sans dark:border-slate700 hover:bg-slate100 hover:dark:bg-slate700">

                                        {row.subLedgerRowspan > 0 ? (
                                            <td rowSpan={row.subLedgerRowspan} className="px-2 py-0.5 border border-slate300 dark:border-slate600">
                                                {row.sub_ledg_name}
                                            </td>
                                        ) : null}
                                        <td className="px-2 py-0.5 border border-slate300 dark:border-slate600">{row?.particularid}. {row?.particularname}</td>
                                        <td className="px-2 py-0.5 border border-slate300 dark:border-slate600 uppercase">{`${Org_Details?.short_name}/${row.glid}/${row.particularid}/${code}`}</td>
                                        <td className="px-2 py-0.5 border border-slate300 dark:border-slate600">{row.countpcs}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.totpurchamt).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.prvamt).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.currpurchamt).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.cursaleamt).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.totamt).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.deprate).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.deprecamt).toFixed(2)}</td>
                                        <td align='end' className="px-2 py-0.5 border border-slate300 dark:border-slate600">{Number(row.netamt).toFixed(2)}</td>
                                    </tr>
                                )})}

                                {/* Totals row */}
                                <tr className="bg-slate-100 text-[12px] text-slate-800 dark:text-slate-400 dark:bg-slate-700 border-b font-public-sans dark:border-slate-600 font-bold">
                                    <td colSpan="3" className="px-2 py-0.5 border dark:border-slate-600 text-right">Total:</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{totals.countpcs}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.totpurchamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.prvamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.currpurchamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.cursaleamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.totamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600"></td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.deprecamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.netamt).toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Fragment>
                </div>
            </div>
        </Fragment>
    );
};

export default PrintAssetsReportView;
